import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import ListItemText from '@mui/material/ListItemText';
import { alpha, useTheme } from '@mui/material/styles';

import { stringToColor } from 'src/utils/string-to-color';

import { bgGradient } from 'src/theme/css';

// ----------------------------------------------------------------------

// Who the student is, at a glance: name, then grade, school and ASN. The
// school dashboards use it too, with the school's code in place of an ASN.
export default function ProfileCover({ name, school, asn, grade, schoolCode }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.primary.darker, 0.8),
          imgUrl: '/assets/images/covers/cover_4.jpg',
        }),
        height: 1,
        color: 'common.white',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{
          left: { md: 24 },
          bottom: { md: 24 },
          zIndex: { md: 10 },
          pt: { xs: 6, md: 0 },
          position: { md: 'absolute' },
        }}
      >
        <Avatar
          sx={{
            mx: 'auto',
            width: { xs: 64, md: 128 },
            height: { xs: 64, md: 128 },
            bgcolor: stringToColor(name),
            fontSize: { xs: 24, md: 32 },
          }}
          children={(() => {
            if (name && name.split(' ').length > 1) {
              return `${name.split(' ')[0][0] || ''}${name.split(' ')[1][0] || ''}`;
            }
            if (name && name.length > 0) {
              return name[0];
            }
            return '?';
          })()}
        />

        <ListItemText
          sx={{
            mt: 3,
            ml: { md: 3 },
            textAlign: { xs: 'center', md: 'unset' },
          }}
          primary={<>{name}</>}
          secondary={[grade && `Grade ${grade}`, school, schoolCode && `School code ${schoolCode}`, asn && `ASN ${asn}`].filter(Boolean).join(' · ')}
          primaryTypographyProps={{
            typography: 'h4',
          }}
          secondaryTypographyProps={{
            mt: 0.5,
            color: 'inherit',
            component: 'span',
            typography: 'body2',
            sx: { opacity: 0.72 },
          }}
        />
      </Stack>
    </Box>
  );
}

ProfileCover.propTypes = {
  name: PropTypes.string,
  school: PropTypes.string,
  asn: PropTypes.string,
  grade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  schoolCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
